module.exports = __webpack_public_path__ + "static/media/BharatVideoLive.8158b004.png";